/* eslint-disable global-require */
const Intl = window.Intl ?? require('intl');

const getBrowserLang = () => new Intl.DateTimeFormat().resolvedOptions().locale.split('-')[0];

export default getBrowserLang;
/* eslint-enable global-require */
